import { HStack } from "@/components/layout/HStack";
import { VStack } from "@/components/layout/VStack";
import { Button } from "@/components/ui/Button/Button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/Collapsible/Collapsible";
import { DashboardCard } from "@/components/ui/DashboardCard/DashboardCard";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/Empty/Empty";
import { Skeleton } from "@/components/ui/Skeleton/Skeleton";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/Tooltip/Tooltip";
import { format } from "date-fns";
import { BookOpen, Eye, EyeClosed, ListChecks } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const UpcomingExplorations = ({
  data,
  loading,
}: {
  data: any;
  loading: boolean;
}) => {
  const [open, setOpen] = useState<boolean>(true);

  useEffect(() => {
  }, [data]);

  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      style={{ marginTop: "-8px" }}
    >
      <VStack gap="2rem">
        <VStack gap={0}>
          <HStack>
            <h3
              style={{
                fontSize: "var(--text-lg)",
                lineHeight: "var(--line-height-lg)",
                fontWeight: "var(--font-bold)",
              }}
            >
              Upcoming Explorations
            </h3>
            <Tooltip>
              <TooltipTrigger asChild>
                <CollapsibleTrigger asChild>
                  <Button variant="ghost" size="icon-small">
                    {open ? <EyeClosed /> : <Eye />}
                  </Button>
                </CollapsibleTrigger>
              </TooltipTrigger>
              <TooltipContent>
                {open ? "Hide" : "Show"} upcoming explorations section.
              </TooltipContent>
            </Tooltip>
          </HStack>
          <p style={{ color: "var(--muted-foreground)" }}>
            You explorations within the next week
          </p>
        </VStack>
        <CollapsibleContent>
          {loading ? (
            <HStack gap="1rem">
              <Skeleton style={{ height: "320px", width: "100%" }} />
              <Skeleton style={{ height: "320px", width: "100%" }} />
              <Skeleton style={{ height: "320px", width: "100%" }} />
              <Skeleton style={{ height: "320px", width: "100%" }} />
            </HStack>
          ) : !data.data || data.data.length < 1 ? (
            <Empty style={{ borderColor: "var(--secondary-border)" }}>
              <EmptyHeader>
                <EmptyMedia variant="icon">
                  <BookOpen />
                </EmptyMedia>
                <EmptyTitle>No Upcoming Explorations Found</EmptyTitle>
                <EmptyDescription>
                  There were no explorations found for the next week. If you
                  believe this is an error, please refresh.
                </EmptyDescription>
              </EmptyHeader>
            </Empty>
          ) : (
            <HStack gap="1rem" style={{ flexWrap: "wrap" }}>
              {data.data.map((e: any) => (
                <DashboardCard
                  key={e._id}
                  style={{
                    flex: "1 1 calc(20% - 1rem)",
                    flexWrap: "nowrap",
                  }}
                >
                  <VStack
                    justify="space-between"
                    gap="1rem"
                    style={{ height: "100%" }}
                  >
                    <VStack gap="1rem">
                      <VStack gap="0.25rem">
                        <p
                          style={{
                            fontSize: "var(--text-md)",
                            lineHeight: "var(--line-height-md)",
                            fontWeight: "var(--font-bold)",
                          }}
                        >
                          {e.exploration.name}
                        </p>
                        <p
                          style={{
                            fontSize: "var(--text-xs)",
                            lineHeight: "var(--line-height-xs)",
                            color: "var(--muted-foreground)",
                          }}
                        >
                          {e.exploration.description}
                        </p>
                      </VStack>
                      <VStack gap="0.125rem">
                        <p>Date: {format(e.rotation.date, "MMMM dd, yyyy")}</p>
                        <p>Session: {e.session.name}</p>
                        <p>
                          Teacher:{" "}
                          {
                            data.teachers.find(
                              (t: any) => t._id === e.exploration.teacher,
                            ).name
                          }
                        </p>
                        {e.exploration.coTeachers.length > 0 && (
                          <p>
                            Co-Teachers:{" "}
                            {e.exploration.coTeachers
                              ?.map(
                                (c: string) =>
                                  data.teachers.find((t: any) => t._id === c)
                                    .name,
                              )
                              .join(", ")}
                          </p>
                        )}
                        <p>
                          Grade Levels: {e.exploration.gradeLevels.join(", ")}
                        </p>
                        <p>Pathway: {e.exploration.pathway}</p>
                        <p>Room: {e.exploration.room}</p>
                        <p>
                          {e.exploration.enrolled} /{" "}
                          {e.exploration.maxEnrollment} enrolled
                        </p>
                      </VStack>
                    </VStack>
                    <Button
                      size="small"
                      asChild
                      style={{ textDecoration: "none" }}
                    >
                      <Link to={`/attendance/${e.class._id}`}>
                        <ListChecks /> Attendance
                      </Link>
                    </Button>
                  </VStack>
                </DashboardCard>
              ))}
            </HStack>
          )}
        </CollapsibleContent>
      </VStack>
    </Collapsible>
  );
};

export { UpcomingExplorations };
